<template>
  <div class="sidebar-footer">
    <div class="user-container">
      <img
        class="picture"
        :src="
          user.image_id
            ? getImage(user.image_id)
            : getRandomUserPicture(user.first_name)
        "
        alt="picture"
      />
      <transition name="fade">
        <div v-if="animationIsFinished && sidebarIsOpen" class="identity">
          <span>{{ user.first_name }} {{ user.last_name }}</span>
          <small>{{
            user.position ? user.position : companyStore.currentCompany.name
          }}</small>
        </div>
      </transition>
    </div>
    <div
      class="settings-container"
      :class="{ withSwitch: companies.length > 1 }"
    >
      <router-link class="settings-link" :to="{ name: 'profil' }">
        <i class="bi bi-person-lines-fill" />
        <span v-text="$t('profil.label')" />
      </router-link>
      <v-select
        v-if="companies.length > 1"
        id="campaign-space"
        :placeholder="$t('campaign.newPage.selectSpace')"
        name="campaign-space"
        label="name"
        :modelValue="companyStore.currentCompany"
        :clearable="false"
        :options="companies"
        :searchable="false"
        @update:modelValue="(event) => switchOfCompany(event)"
      >
        <template #selected-option="{ name }">
          <div class="custom-selected-option">
            <i class="bi bi-globe" />
            <span>{{ name }}</span>
          </div>
        </template>
        <template v-slot:no-options="{ search, searching }">
          <div style="padding: 8px 0">
            Pas de résultat {{ searching ? ` pour ${search}` : "" }}.
          </div>
        </template>
      </v-select>
      <div v-if="false" class="grouped-button">
        <Button
          class="icon icon-left sm full-size"
          :class="$i18n.locale.includes('fr') ? 'secondary' : 'transparent'"
          :label="$t('global.french')"
          icon="bi bi-flag"
          @click="setLang('fr-FR')"
        />
        <Button
          class="icon icon-left sm full-size"
          :class="$i18n.locale.includes('en') ? 'secondary' : 'transparent'"
          :label="$t('global.english')"
          icon="bi bi-flag"
          @click="setLang('en-EN')"
        />
      </div>
      <div class="grouped-button">
        <Button
          class="icon icon-left sm full-size"
          :class="!isDark ? 'secondary' : 'transparent'"
          :label="$t('global.light')"
          icon="bi bi-sun"
          @click="toggleDark()"
        />
        <Button
          class="icon icon-left sm full-size"
          :class="isDark ? 'secondary' : 'transparent'"
          :label="$t('global.dark')"
          icon="bi bi-moon"
          @click="toggleDark()"
        />
      </div>
      <Button
        class="red icon icon-right full-size"
        :label="$t('actions.logout')"
        icon="bi bi-power"
        @click="logout()"
      />
    </div>
  </div>
</template>

<script setup>
import { useDark, useToggle } from "@vueuse/core";
import { useUserStore } from "@/stores/user.js";
import { useCompanyStore } from "@/stores/company.js";
import { useI18n } from "vue-i18n";
import { getImage, getRandomUserPicture } from "@/composables/getImage.js";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";

const router = useRouter();

const { user, logout } = useUserStore();

const companyStore = useCompanyStore();

const { companies } = storeToRefs(companyStore);

const i18n = useI18n({ useScope: "global" });

defineProps({
  animationIsFinished: {
    type: Boolean,
    required: true,
  },
  sidebarIsOpen: {
    type: Boolean,
    required: true,
  },
});

const isDark = useDark();
const toggleDark = useToggle(isDark);

async function switchOfCompany(companyObject) {
  if (
    !companies.value.find(
      (elt) => elt.company_id === companyObject.company_id && elt.creation_time
    )
  ) {
    await companyStore.getCompany(companyObject.company_id);
  }

  router.push({
    name: "home",
    params: { companyId: companyObject.company_id },
  });
}

function setLang(lang) {
  localStorage.setItem("yuzuLocale", lang);
  i18n.locale.value = lang;
}
</script>
